import { apiClient } from './api';

// EG-52 — Platform Admin xem voucher cross-tenant.
// BE endpoint: GET /vouchers, GET /vouchers/:id (read-only).

export interface VoucherFilters {
  page?: number;
  limit?: number;
  tenant_id?: string;
  status?: string;
  type?: string;
  q?: string;
}

export interface Voucher {
  voucher_id: string;
  tenant_id?: string;
  code: string;
  source?: string;
  type: string;
  value: number;
  max_discount?: number;
  status: string;
  description?: string;
  usage_limit_total?: number;
  usage_count?: number;
  start_date?: string;
  end_date?: string;
  created_at: string;
  updated_at?: string;
}

export interface VouchersResponse {
  data: Voucher[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

interface VoucherApiRaw {
  voucher_id?: string;
  _id?: string;
  tenant_id?: string;
  code?: string;
  source?: string;
  type?: string;
  value?: number;
  max_discount?: number;
  status?: string;
  description?: string;
  usage_limit_total?: number;
  usage_count?: number;
  start_date?: string;
  end_date?: string;
  created_at?: string;
  updated_at?: string;
}

const toVoucher = (raw: VoucherApiRaw): Voucher => ({
  voucher_id: raw.voucher_id || raw._id || '',
  tenant_id: raw.tenant_id,
  code: raw.code || '',
  source: raw.source,
  type: raw.type || '',
  value: raw.value ?? 0,
  max_discount: raw.max_discount,
  status: raw.status || '',
  description: raw.description,
  usage_limit_total: raw.usage_limit_total,
  usage_count: raw.usage_count,
  start_date: raw.start_date,
  end_date: raw.end_date,
  created_at: raw.created_at || '',
  updated_at: raw.updated_at,
});

export const voucherService = {
  getVouchers: async (filters: VoucherFilters = {}): Promise<VouchersResponse> => {
    const response = await apiClient.get<Envelope<{ items: VoucherApiRaw[]; meta: VouchersResponse['meta'] }>>(
      '/vouchers',
      { params: filters },
    );
    const payload = response.data?.data;
    return {
      data: (payload?.items || []).map(toVoucher),
      meta: payload?.meta || {
        page: filters.page || 1,
        limit: filters.limit || 20,
        total: 0,
        totalPages: 0,
      },
    };
  },

  getVoucherById: async (id: string): Promise<Voucher> => {
    const response = await apiClient.get<Envelope<VoucherApiRaw>>(`/vouchers/${id}`);
    return toVoucher(response.data.data);
  },
};

export default voucherService;
